export function myBookMarkList (mode) {
    return { type: "HANDLE_BOOKMARK_LIST", payload: mode };
  }
  